// Questionnaire data — Atmia Education Feedback (40 questions / 10 steps)

const SCALE_5 = ["Excellent", "Very Good", "Good", "Average", "Needs Improvement"];
const YES_NO_4 = ["Yes, completely", "Mostly yes", "Partially", "Not clearly"];
const YES_NO_4_ALT = ["Yes, completely", "Mostly yes", "Partially", "No"];
const RESPONSIVE = ["Always responsive", "Mostly responsive", "Sometimes responsive", "Not responsive"];
const HELPFUL_4 = ["Yes, very helpful", "Somewhat helpful", "Basic information only", "Not helpful"];
const USEFUL_4 = ["Very useful", "Useful", "Average", "Not useful"];
const ACADEMIC_FIT = ["Yes, fully", "Mostly yes", "Partially", "No"];
const LOCAL_HELP = ["Yes, very helpful", "Helpful", "Average", "Needs Improvement"];
const TIMELY = ["Always", "Mostly", "Sometimes", "Rarely"];
const COMFORT = ["Yes, very comfortable", "Comfortable", "Average", "Needs Improvement"];
const FOOD_SUIT = ["Yes, completely", "Mostly yes", "Average", "Needs Improvement"];
const SERVE_TIME = ["Always", "Mostly", "Sometimes", "Needs Improvement"];
const RECOMMEND = ["Definitely yes", "Yes", "Maybe", "No"];
const SHARE_TESTIMONIAL = ["Yes", "No", "Only with prior approval"];

export const STEPS = [
  {
    id: "basic",
    title: "Basic Details",
    subtitle: "Tell us a bit about yourself.",
    fields: [
      { key: "parent_name", label: "Name of Parent/Student", type: "text", required: true, placeholder: "Full name" },
      { key: "student_name", label: "Student Name", type: "text", required: true, placeholder: "Student's full name" },
      { key: "university_name", label: "University Name", type: "text", readonly: true, default: "SEU – Georgian National University, Georgia" },
      { key: "batch_year", label: "Batch / Year of Admission", type: "text", required: true, placeholder: "e.g., 2024" },
      { key: "contact_number", label: "Contact Number", type: "tel", required: true, placeholder: "+91 ..." },
      { key: "city_branch", label: "City / Branch through which admission was taken", type: "text", required: true, placeholder: "e.g., Ahmedabad" },
    ],
  },
  {
    id: "counselling",
    title: "Counselling & Admission Guidance",
    subtitle: "Section 2 of 10",
    questions: [
      { id: "q1", n: 1, q: "How satisfied were you with the information provided by our counsellor about SEU – Georgian National University?", type: "radio", options: SCALE_5 },
      { id: "q2", n: 2, q: "Was the counsellor able to clearly explain the university details, fee structure, admission process, visa process, and documentation?", type: "radio", options: YES_NO_4 },
      { id: "q3", n: 3, q: "How would you rate the overall support provided by our counsellor during the admission process?", type: "radio", options: SCALE_5 },
      { id: "q4", n: 4, q: "Was the counsellor responsive to your calls, messages, and queries?", type: "radio", options: RESPONSIVE },
      { id: "q5", n: 5, q: "Did you receive proper guidance regarding MBBS in Georgia and future medical career pathways?", type: "radio", options: HELPFUL_4 },
    ],
  },
  {
    id: "documentation",
    title: "Documentation, Visa & Pre-Departure Support",
    subtitle: "Section 3 of 10",
    questions: [
      { id: "q6", n: 6, q: "How satisfied were you with the documentation support provided by Atmia Education?", type: "radio", options: SCALE_5 },
      { id: "q7", n: 7, q: "How was the visa support and guidance provided by Atmia Education?", type: "radio", options: SCALE_5 },
      { id: "q8", n: 8, q: "Were you properly informed about travel planning, ticket booking, airport assistance, and arrival arrangements?", type: "radio", options: YES_NO_4_ALT },
      { id: "q9", n: 9, q: "How useful was the pre-departure guidance/session provided by Atmia Education?", type: "radio", options: USEFUL_4 },
    ],
  },
  {
    id: "campus",
    title: "SEU – Georgian National University Campus Experience",
    subtitle: "Section 4 of 10",
    questions: [
      { id: "q10", n: 10, q: "How would you rate the overall SEU – Georgian National University campus?", type: "radio", options: SCALE_5 },
      { id: "q11", n: 11, q: "How satisfied are you with the infrastructure and facilities available at SEU?", type: "radio", options: SCALE_5 },
      { id: "q12", n: 12, q: "How would you rate the quality of education at SEU – Georgian National University?", type: "radio", options: SCALE_5 },
      { id: "q13", n: 13, q: "Are the classes, faculty, and academic environment meeting your expectations?", type: "radio", options: ACADEMIC_FIT },
      { id: "q14", n: 14, q: "How would you rate the practical exposure, teaching methods, and academic support at SEU?", type: "radio", options: SCALE_5 },
    ],
  },
  {
    id: "support_georgia",
    title: "Support Provided by Atmia in Georgia",
    subtitle: "Section 5 of 10",
    questions: [
      { id: "q15", n: 15, q: "How satisfied are you with the overall support provided by Atmia Education after reaching Georgia?", type: "radio", options: SCALE_5 },
      { id: "q16", n: 16, q: "Was Atmia Education's local support team helpful in settling the student in Georgia?", type: "radio", options: LOCAL_HELP },
      { id: "q17", n: 17, q: "How would you rate the communication and coordination from Atmia Education after admission?", type: "radio", options: SCALE_5 },
      { id: "q18", n: 18, q: "Did Atmia Education provide timely support whenever required?", type: "radio", options: TIMELY },
    ],
  },
  {
    id: "accommodation",
    title: "Accommodation / Hostel Support",
    subtitle: "Section 6 of 10",
    questions: [
      { id: "q19", n: 19, q: "How satisfied are you with the accommodation/hostel support provided by Atmia Education?", type: "radio", options: SCALE_5 },
      { id: "q20", n: 20, q: "How would you rate the hostel cleanliness and hygiene?", type: "radio", options: SCALE_5 },
      { id: "q21", n: 21, q: "How would you rate the safety and security of the hostel/accommodation?", type: "radio", options: SCALE_5 },
      { id: "q22", n: 22, q: "Are the hostel facilities comfortable for students?", type: "radio", options: COMFORT },
    ],
  },
  {
    id: "food",
    title: "Food – Atmia Saffron Kingdom",
    subtitle: "Section 7 of 10",
    questions: [
      { id: "q23", n: 23, q: "How satisfied are you with the food provided at Atmia Saffron Kingdom?", type: "radio", options: SCALE_5 },
      { id: "q24", n: 24, q: "How would you rate the taste and quality of food?", type: "radio", options: SCALE_5 },
      { id: "q25", n: 25, q: "How would you rate the hygiene and cleanliness maintained in food preparation and dining?", type: "radio", options: SCALE_5 },
      { id: "q26", n: 26, q: "Is the food suitable for Indian/Gujarati students?", type: "radio", options: FOOD_SUIT },
      { id: "q27", n: 27, q: "Are meals served on time?", type: "radio", options: SERVE_TIME },
    ],
  },
  {
    id: "overall",
    title: "Overall Experience",
    subtitle: "Section 8 of 10",
    questions: [
      { id: "q28", n: 28, q: "Overall, how satisfied are you with Atmia Education's services?", type: "radio", options: SCALE_5 },
      { id: "q29", n: 29, q: "Would you recommend Atmia Education to other parents/students planning for MBBS abroad?", type: "radio", options: RECOMMEND },
      { id: "q30", n: 30, q: "How would you rate your trust and confidence in Atmia Education?", type: "radio", options: SCALE_5 },
      { id: "q31", n: 31, q: "What was the best part of your experience with Atmia Education?", type: "textarea", placeholder: "Share what you loved most..." },
      {
        id: "q32",
        n: 32,
        q: "Which services did you find most helpful? (Select all that apply)",
        type: "checkbox",
        options: [
          "Counselling", "Admission Support", "Documentation", "Visa Support", "Travel Support",
          "Georgia Local Support", "Hostel Support", "Food Support", "Academic Guidance", "Overall Coordination",
        ],
      },
    ],
  },
  {
    id: "improve",
    title: "Areas to Improve",
    subtitle: "Section 9 of 10",
    questions: [
      {
        id: "q33",
        n: 33,
        q: "Which areas do you feel Atmia Education should improve? (Select all that apply)",
        type: "checkbox",
        options: [
          "Counselling & Information", "Admission Process", "Documentation Support", "Visa Guidance",
          "Communication & Follow-up", "Travel Assistance", "Local Support in Georgia", "Hostel Facilities",
          "Food Quality", "Academic Coordination", "Parent Updates",
        ],
        allowOther: true,
      },
      { id: "q34", n: 34, q: "Please mention any specific issue or concern you faced, if any.", type: "textarea", placeholder: "Optional" },
      { id: "q35", n: 35, q: "What improvements would you suggest for Atmia Education?", type: "textarea", placeholder: "Your suggestions..." },
      { id: "q36", n: 36, q: "Any suggestions regarding hostel/accommodation?", type: "textarea", placeholder: "Optional" },
      { id: "q37", n: 37, q: "Any suggestions regarding food at Atmia Saffron Kingdom?", type: "textarea", placeholder: "Optional" },
    ],
  },
  {
    id: "final",
    title: "Final Feedback",
    subtitle: "Section 10 of 10 — almost done!",
    questions: [
      { id: "q38", n: 38, q: "Please share your overall feedback in your own words.", type: "textarea", placeholder: "Tell us in your own words..." },
      { id: "q39", n: 39, q: "Would you be comfortable sharing your feedback/testimonial for Atmia Education's official use?", type: "radio", options: SHARE_TESTIMONIAL },
      { id: "q40", n: 40, q: "Your final rating for Atmia Education", type: "stars", maxStars: 5 },
    ],
  },
];

export const TOTAL_STEPS = STEPS.length;
